export async function getVerifiedZipBlob(response) {
  const blob = await response.blob();
  const signature = new Uint8Array(await blob.slice(0, 4).arrayBuffer());
  const isZip =
    signature.length === 4 &&
    signature[0] === 0x50 &&
    signature[1] === 0x4b &&
    ((signature[2] === 0x03 && signature[3] === 0x04) ||
      (signature[2] === 0x05 && signature[3] === 0x06) ||
      (signature[2] === 0x07 && signature[3] === 0x08));

  if (!isZip) {
    throw new Error("เซิร์ฟเวอร์ไม่ได้ส่งไฟล์ ZIP ที่สมบูรณ์ กรุณาลองใหม่อีกครั้ง");
  }

  return blob;
}
